import { Component, inject, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FroExoResAddr } from '@app/interfaces/FroExoResAddr';
import { ReservationService } from '@app/services/reservation.service';
import { YesNoDialogComponent } from '@app/dialogs/yes-no-dialog/yes-no-dialog.component';
import { GenericMessage } from '@app/interfaces/generic-message';
import { TranslateService } from '@ngx-translate/core';

export interface InvoiceAddressSelectionDialogData {
  items: FroExoResAddr[];
}

@Component({
  selector: 'app-invoice-address-selection-dialog',
  templateUrl: './invoice-address-selection-dialog.component.html',
  styleUrls: ['./invoice-address-selection-dialog.component.scss']
})
export class InvoiceAddressSelectionDialogComponent implements OnInit {

  reservationAddresses: FroExoResAddr[];
  reservationService = inject(ReservationService)
  dialog = inject(MatDialog)
  translate = inject(TranslateService)
  rinf = JSON.parse(sessionStorage.getItem('rinf'))
  gsui = sessionStorage.getItem('gsui')
  guestData

  constructor(
    private dialogRef: MatDialogRef<InvoiceAddressSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: InvoiceAddressSelectionDialogData
  ) {
    this.reservationAddresses = data.items;
  }

  ngOnInit(): void {
    this.reservationService.getGuestStayAddress(this.rinf.Hotel3pId, this.gsui).subscribe(data => this.guestData = data)
  }

  addressLine(item: FroExoResAddr): string {
    return `${item.ZipCode ?? ''}   ${item.City ?? ''} ${item.Street ?? ''}`;
  }

  select(item: FroExoResAddr) {
    if (item.AType !== 3 || item.AType === null) {
      const messageData: GenericMessage = {
        messageText: this.translate.instant('invoice_details.advance_invoice_selection_confirm'),
        messageType: 'WARNING',
        showIcon: true
      };
      this.dialog.open(YesNoDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: 'auto',
        data: messageData
      }).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.dialogRef.close(item);
        }
      });
      return;
    }
    this.dialogRef.close(item);
  }

  enterManually() {
    this.dialogRef.close();
  }
}
